import R from 'ramda'

/**
 * Add a newly created folder to the user's folders
 * @param {Object} folder - The new folder returned by the endpoint
 * @param {Array} folders - The array of folders from the current state
 */
export default function addNewFolder(folder, folders) {
  // Increment each existing folder's position (the new folder comes back with position: 1)
  const repositionedFolders = folders.map(f => ({
    ...f,
    position: R.inc(f.position),
  }))

  // Prepend the new folder to the repositioned folders
  // NB: It actually doesn't matter if we prepend or append the new folder to the folders array,
  // since manual sorting looks at position properties and not array indexes.
  // R.prepend is only used here to be thematically consistent.
  return R.prepend(folder, repositionedFolders)
}
